<div class="hero-container my-3"><ng-template omHero></ng-template></div>
